// eslint-disable-next-line no-restricted-imports
import { Tabs } from '@mui/material';
import { CSSObject, styled } from 'libs/ui/styled';

import { Colors } from '../theme';

export const TabsStyled = styled(Tabs)(() => ({
  minHeight: 36,
  '.MuiTabs-list': {
    display: 'flex',
    gap: 32,
  } as CSSObject,

  '.MuiTabs-indicator': {
    bottom: 0,
    backgroundColor: Colors.blue500,
  } as CSSObject,
}));
